import React, { memo } from 'react';
import { SubsidiaryHeader } from '../../../components/shared/SubsidiaryHeader';
import { SubsidiaryFooter } from '../../../components/shared/SubsidiaryFooter';
import { motion } from 'framer-motion';
const navigation = [{
  name: 'Home',
  href: '/standard-purity'
}, {
  name: 'Experiences',
  href: '#experiences'
}, {
  name: 'Dining & Drinks',
  href: '#dining'
}, {
  name: 'Events',
  href: '#events'
}, {
  name: 'About',
  href: '#about'
}, {
  name: 'Contact',
  href: '#contact'
}];
const footerLinks = [{
  title: 'Experiences',
  items: [{
    name: 'Lounge & Bar',
    href: '#'
  }, {
    name: 'Restaurant',
    href: '#'
  }, {
    name: 'Live Music',
    href: '#'
  }, {
    name: 'Private Events',
    href: '#'
  }]
}, {
  title: 'Company',
  items: [{
    name: 'Our Story',
    href: '#'
  }, {
    name: 'Team',
    href: '#'
  }, {
    name: 'Careers',
    href: '#'
  }, {
    name: 'Gallery',
    href: '#'
  }]
}];
const experiences = [{
  id: 'lounge',
  name: 'Premium Lounge',
  description: 'Luxurious lounge area with comfortable seating, ambient lighting, and premium service.',
  price: 'No cover charge',
  image: 'https://images.unsplash.com/photo-1517457373958-b7bdd4587205?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1974&q=80'
}, {
  id: 'restaurant',
  name: 'Fine Dining Restaurant',
  description: 'Exquisite cuisine prepared by our award-winning chefs using the finest ingredients.',
  price: 'Reservations recommended',
  image: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
}, {
  id: 'bar',
  name: 'Signature Cocktail Bar',
  description: 'Artisanal cocktails crafted by expert mixologists using premium spirits and fresh ingredients.',
  price: 'Happy Hour 5-7pm',
  image: 'https://images.unsplash.com/photo-1470337458703-46ad1756a187?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2069&q=80'
}, {
  id: 'entertainment',
  name: 'Live Entertainment',
  description: 'Regular performances featuring local and international artists, DJs, and themed nights.',
  price: 'Check events calendar',
  image: 'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
}];
export function StandardPurityHome() {
  return <div className="flex flex-col min-h-screen" data-id="element-1013">
      <SubsidiaryHeader name="Standard Purity Ent." color="bg-emerald-50 text-emerald-900" navigation={navigation} logo="https://uploadthingy.s3.us-west-1.amazonaws.com/pbBPYdNqJU1QtNxrehs2c8/STANDARD_PURITY_2.png" data-id="element-1014" />
      <main className="flex-grow" data-id="element-1015">
        {/* Hero Section */}
        <section className="relative h-[70vh]" data-id="element-1016">
          <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1566417713940-fe7c737a9ef2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2029&q=80')] bg-cover bg-center" data-id="element-1017"></div>
          <div className="absolute inset-0 bg-emerald-900/50" data-id="element-1018"></div>
          <div className="relative z-10 container mx-auto px-4 h-full flex items-center" data-id="element-1019">
            <div className="max-w-xl text-white" data-id="element-1020">
              <motion.h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6" initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.7
            }} data-id="element-1021">
                Lagos' Premier Entertainment Hub
              </motion.h1>
              <motion.p className="text-xl md:text-2xl mb-8" initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.7,
              delay: 0.2
            }} data-id="element-1022">
                Experience the perfect blend of fine dining, premium cocktails,
                and exceptional entertainment in an elegant setting.
              </motion.p>
              <motion.div className="flex flex-wrap gap-4" initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.7,
              delay: 0.4
            }} data-id="element-1023">
                <motion.a href="#experiences" className="px-6 py-3 bg-emerald-600 text-white font-medium rounded-md hover:bg-emerald-700 transition-colors" whileHover={{
                scale: 1.05
              }} whileTap={{
                scale: 0.95
              }} data-id="element-1024">
                  Explore Experiences
                </motion.a>
                <motion.a href="#contact" className="px-6 py-3 bg-transparent border border-white text-white font-medium rounded-md hover:bg-white/10 transition-colors" whileHover={{
                scale: 1.05
              }} whileTap={{
                scale: 0.95
              }} data-id="element-1025">
                  Reservations
                </motion.a>
              </motion.div>
            </div>
          </div>
        </section>
        {/* Experiences Section */}
        <section id="experiences" className="py-20" data-id="element-1026">
          <div className="container mx-auto px-4" data-id="element-1027">
            <motion.div className="text-center mb-16" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.7
          }} data-id="element-1028">
              <h2 className="text-3xl font-bold text-emerald-900 mb-4" data-id="element-1029">
                Unforgettable Experiences
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-1030">
                Discover the diverse range of experiences we offer, each
                designed to provide the perfect atmosphere for relaxation,
                celebration, and entertainment.
              </p>
            </motion.div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-1031">
              {experiences.map((experience, index) => <motion.div key={experience.id} className="bg-white rounded-lg shadow-md overflow-hidden" initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.1
            }} whileHover={{
              y: -10
            }} data-id="element-1032">
                  <div className="h-48 overflow-hidden" data-id="element-1033">
                    <img src={experience.image} alt={experience.name} className="w-full h-full object-cover transition-transform duration-500 hover:scale-110" data-id="element-1034" />
                  </div>
                  <div className="p-6" data-id="element-1035">
                    <h3 className="text-xl font-bold text-emerald-800 mb-2" data-id="element-1036">
                      {experience.name}
                    </h3>
                    <p className="text-gray-600 mb-4" data-id="element-1037">
                      {experience.description}
                    </p>
                    <div className="flex justify-between items-center" data-id="element-1038">
                      <span className="text-md font-bold text-emerald-700" data-id="element-1039">
                        {experience.price}
                      </span>
                      <motion.button className="px-4 py-2 bg-emerald-600 text-white rounded-md hover:bg-emerald-700 transition-colors" whileHover={{
                    scale: 1.05
                  }} whileTap={{
                    scale: 0.95
                  }} data-id="element-1040">
                        Learn More
                      </motion.button>
                    </div>
                  </div>
                </motion.div>)}
            </div>
            <div className="mt-12 text-center" data-id="element-1041">
              <motion.a href="#" className="px-6 py-3 bg-emerald-600 text-white font-medium rounded-md hover:bg-emerald-700 transition-colors inline-block" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} data-id="element-1042">
                View All Experiences
              </motion.a>
            </div>
          </div>
        </section>
        {/* Dining & Drinks Section */}
        <section id="dining" className="py-20 bg-emerald-50" data-id="element-1043">
          <div className="container mx-auto px-4" data-id="element-1044">
            <motion.div className="text-center mb-16" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.7
          }} data-id="element-1045">
              <h2 className="text-3xl font-bold text-emerald-900 mb-4" data-id="element-1046">
                Dining & Drinks
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-1047">
                Indulge in exceptional cuisine and handcrafted beverages in our
                elegant restaurant and bar.
              </p>
            </motion.div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1048">
              <motion.div className="bg-white p-8 rounded-lg shadow-md" initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5
            }} data-id="element-1049">
                <div className="text-4xl text-emerald-600 mb-4" data-id="element-1050">🍽️</div>
                <h3 className="text-xl font-bold text-emerald-800 mb-3" data-id="element-1051">
                  Restaurant
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-1052">
                  Our restaurant offers a diverse menu of local and
                  international cuisine prepared with the freshest ingredients
                  by our talented culinary team.
                </p>
                <motion.a href="#" className="text-emerald-600 font-medium hover:text-emerald-700" whileHover={{
                x: 5
              }} data-id="element-1053">
                  View Menu →
                </motion.a>
              </motion.div>
              <motion.div className="bg-white p-8 rounded-lg shadow-md" initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.1
            }} data-id="element-1054">
                <div className="text-4xl text-emerald-600 mb-4" data-id="element-1055">🍸</div>
                <h3 className="text-xl font-bold text-emerald-800 mb-3" data-id="element-1056">
                  Cocktail Bar
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-1057">
                  Our skilled mixologists craft innovative cocktails using
                  premium spirits, fresh fruits, and house-made infusions for a
                  unique drinking experience.
                </p>
                <motion.a href="#" className="text-emerald-600 font-medium hover:text-emerald-700" whileHover={{
                x: 5
              }} data-id="element-1058">
                  Drink Menu →
                </motion.a>
              </motion.div>
              <motion.div className="bg-white p-8 rounded-lg shadow-md" initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.2
            }} data-id="element-1059">
                <div className="text-4xl text-emerald-600 mb-4" data-id="element-1060">🎵</div>
                <h3 className="text-xl font-bold text-emerald-800 mb-3" data-id="element-1061">
                  Live Music
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-1062">
                  Enjoy performances by talented local and international artists
                  while you dine and drink in our sophisticated atmosphere.
                </p>
                <motion.a href="#" className="text-emerald-600 font-medium hover:text-emerald-700" whileHover={{
                x: 5
              }} data-id="element-1063">
                  Events Calendar →
                </motion.a>
              </motion.div>
            </div>
          </div>
        </section>
        {/* Events Section */}
        <section id="events" className="py-20" data-id="element-1064">
          <div className="container mx-auto px-4" data-id="element-1065">
            <div className="flex flex-col lg:flex-row gap-12 items-center" data-id="element-1066">
              <motion.div className="lg:w-1/2" initial={{
              opacity: 0,
              x: -30
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.7
            }} data-id="element-1067">
                <h2 className="text-3xl font-bold text-emerald-900 mb-6" data-id="element-1068">
                  Private Events & Celebrations
                </h2>
                <p className="text-gray-700 mb-6" data-id="element-1069">
                  Standard Purity Entertainment offers the perfect venue for
                  your private events and special celebrations. From corporate
                  gatherings to birthday parties, our team will ensure a
                  memorable experience.
                </p>
                <p className="text-gray-700 mb-6" data-id="element-1070">
                  Our event spaces can accommodate groups of various sizes, and
                  our dedicated event planning team will work with you to
                  customize every aspect of your event, from the menu to the
                  entertainment.
                </p>
                <p className="text-gray-700 mb-6" data-id="element-1071">
                  Whether you're planning an intimate gathering or a large
                  celebration, we provide the perfect atmosphere, exceptional
                  service, and attention to detail that will exceed your
                  expectations.
                </p>
                <div className="flex flex-wrap gap-4" data-id="element-1072">
                  <div className="bg-emerald-50 p-4 rounded-lg" data-id="element-1073">
                    <h3 className="font-bold text-emerald-700" data-id="element-1074">
                      Corporate Events
                    </h3>
                    <p className="text-gray-700" data-id="element-1075">
                      Professional atmosphere with state-of-the-art audiovisual
                      equipment and customizable catering options.
                    </p>
                  </div>
                  <div className="bg-emerald-50 p-4 rounded-lg" data-id="element-1076">
                    <h3 className="font-bold text-emerald-700" data-id="element-1077">
                      Private Celebrations
                    </h3>
                    <p className="text-gray-700" data-id="element-1078">
                      Elegant spaces for birthdays, anniversaries, and special
                      occasions with personalized service.
                    </p>
                  </div>
                </div>
              </motion.div>
              <motion.div className="lg:w-1/2" initial={{
              opacity: 0,
              x: 30
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.7
            }} data-id="element-1079">
                <img src="https://images.unsplash.com/photo-1511795409834-ef04bbd61622?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2069&q=80" alt="Private event at Standard Purity" className="rounded-lg shadow-lg w-full" data-id="element-1080" />
              </motion.div>
            </div>
          </div>
        </section>
        {/* About Section */}
        <section id="about" className="py-20 bg-emerald-50" data-id="element-1081">
          <div className="container mx-auto px-4" data-id="element-1082">
            <motion.div className="text-center mb-16" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.7
          }} data-id="element-1083">
              <h2 className="text-3xl font-bold text-emerald-900 mb-4" data-id="element-1084">
                Our Story
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-1085">
                Learn about our journey to becoming Lagos' premier entertainment
                destination.
              </p>
            </motion.div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1086">
              <motion.div className="bg-white p-6 rounded-lg shadow-md" initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5
            }} data-id="element-1087">
                <div className="text-emerald-500 text-4xl mb-4" data-id="element-1088">01</div>
                <h3 className="text-xl font-bold text-emerald-800 mb-3" data-id="element-1089">
                  Our Beginning
                </h3>
                <p className="text-gray-700" data-id="element-1090">
                  Founded in 2010, Standard Purity Entertainment began with a
                  vision to create a sophisticated yet welcoming space where
                  people could enjoy exceptional food, drinks, and
                  entertainment.
                </p>
              </motion.div>
              <motion.div className="bg-white p-6 rounded-lg shadow-md" initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.1
            }} data-id="element-1091">
                <div className="text-emerald-500 text-4xl mb-4" data-id="element-1092">02</div>
                <h3 className="text-xl font-bold text-emerald-800 mb-3" data-id="element-1093">
                  Our Growth
                </h3>
                <p className="text-gray-700" data-id="element-1094">
                  Over the years, we've expanded our offerings, refined our
                  culinary and mixology programs, and cultivated relationships
                  with top entertainers to provide a truly unique experience.
                </p>
              </motion.div>
              <motion.div className="bg-white p-6 rounded-lg shadow-md" initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.2
            }} data-id="element-1095">
                <div className="text-emerald-500 text-4xl mb-4" data-id="element-1096">03</div>
                <h3 className="text-xl font-bold text-emerald-800 mb-3" data-id="element-1097">
                  Today
                </h3>
                <p className="text-gray-700" data-id="element-1098">
                  Today, we're proud to be recognized as one of Lagos' premier
                  entertainment destinations, known for our commitment to
                  excellence, innovation, and creating memorable experiences.
                </p>
              </motion.div>
            </div>
          </div>
        </section>
        {/* Testimonials Section */}
        <section className="py-20" data-id="element-1099">
          <div className="container mx-auto px-4" data-id="element-1100">
            <motion.div className="text-center mb-16" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.7
          }} data-id="element-1101">
              <h2 className="text-3xl font-bold text-emerald-900 mb-4" data-id="element-1102">
                What Our Guests Say
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-1103">
                Don't just take our word for it. Here's what our valued guests
                have to say about their experiences at Standard Purity.
              </p>
            </motion.div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1104">
              <motion.div className="bg-white p-6 rounded-lg shadow-md" initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5
            }} data-id="element-1105">
                <div className="flex items-center mb-4" data-id="element-1106">
                  <div className="text-emerald-500" data-id="element-1107">★★★★★</div>
                </div>
                <p className="text-gray-700 mb-4" data-id="element-1108">
                  "The atmosphere is incredible! The food was delicious, the
                  cocktails were innovative, and the live music created the
                  perfect ambiance for our anniversary dinner."
                </p>
                <div className="font-medium" data-id="element-1109">
                  <p className="text-emerald-800" data-id="element-1110">Michael O.</p>
                  <p className="text-gray-600 text-sm" data-id="element-1111">Lagos</p>
                </div>
              </motion.div>
              <motion.div className="bg-white p-6 rounded-lg shadow-md" initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.1
            }} data-id="element-1112">
                <div className="flex items-center mb-4" data-id="element-1113">
                  <div className="text-emerald-500" data-id="element-1114">★★★★★</div>
                </div>
                <p className="text-gray-700 mb-4" data-id="element-1115">
                  "We held our company event at Standard Purity, and it exceeded
                  all expectations. The staff was attentive, the space was
                  beautiful, and our team is still talking about the amazing
                  food."
                </p>
                <div className="font-medium" data-id="element-1116">
                  <p className="text-emerald-800" data-id="element-1117">Amara F.</p>
                  <p className="text-gray-600 text-sm" data-id="element-1118">Abuja</p>
                </div>
              </motion.div>
              <motion.div className="bg-white p-6 rounded-lg shadow-md" initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.2
            }} data-id="element-1119">
                <div className="flex items-center mb-4" data-id="element-1120">
                  <div className="text-emerald-500" data-id="element-1121">★★★★★</div>
                </div>
                <p className="text-gray-700 mb-4" data-id="element-1122">
                  "The mixologists at the bar are true artists! They created
                  custom cocktails for our group that perfectly matched our
                  preferences. Combined with the live DJ, it made for an
                  unforgettable evening."
                </p>
                <div className="font-medium" data-id="element-1123">
                  <p className="text-emerald-800" data-id="element-1124">Daniel E.</p>
                  <p className="text-gray-600 text-sm" data-id="element-1125">Port Harcourt</p>
                </div>
              </motion.div>
            </div>
          </div>
        </section>
        {/* Contact Section */}
        <section id="contact" className="py-20 bg-emerald-50" data-id="element-1126">
          <div className="container mx-auto px-4" data-id="element-1127">
            <motion.div className="text-center mb-16" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.7
          }} data-id="element-1128">
              <h2 className="text-3xl font-bold text-emerald-900 mb-4" data-id="element-1129">
                Reservations & Inquiries
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-1130">
                Make a reservation, inquire about private events, or send us
                your questions. We're here to help create your perfect
                experience.
              </p>
            </motion.div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-1131">
              <motion.div initial={{
              opacity: 0,
              x: -30
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.7
            }} data-id="element-1132">
                <form className="bg-white p-8 rounded-lg shadow-md" data-id="element-1133">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4" data-id="element-1134">
                    <div data-id="element-1135">
                      <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1136">
                        Name
                      </label>
                      <input type="text" id="name" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none" placeholder="Your name" data-id="element-1137" />
                    </div>
                    <div data-id="element-1138">
                      <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1139">
                        Email
                      </label>
                      <input type="email" id="email" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none" placeholder="Your email" data-id="element-1140" />
                    </div>
                  </div>
                  <div className="mb-4" data-id="element-1141">
                    <label htmlFor="reservation-type" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1142">
                      Reservation Type
                    </label>
                    <select id="reservation-type" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none" data-id="element-1143">
                      <option value="" data-id="element-1144">Select reservation type</option>
                      <option value="dining" data-id="element-1145">Restaurant Dining</option>
                      <option value="lounge" data-id="element-1146">Lounge Seating</option>
                      <option value="event" data-id="element-1147">Private Event</option>
                      <option value="other" data-id="element-1148">Other Inquiry</option>
                    </select>
                  </div>
                  <div className="mb-4" data-id="element-1149">
                    <label htmlFor="date" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1150">
                      Preferred Date & Time
                    </label>
                    <input type="datetime-local" id="date" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none" data-id="element-1151" />
                  </div>
                  <div className="mb-4" data-id="element-1152">
                    <label htmlFor="guests" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1153">
                      Number of Guests
                    </label>
                    <input type="number" id="guests" min="1" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none" placeholder="Number of guests" data-id="element-1154" />
                  </div>
                  <div className="mb-6" data-id="element-1155">
                    <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1156">
                      Special Requests
                    </label>
                    <textarea id="message" rows={3} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none" placeholder="Any special requests or questions" data-id="element-1157"></textarea>
                  </div>
                  <motion.button type="submit" className="w-full py-3 px-4 bg-emerald-600 text-white font-medium rounded-md hover:bg-emerald-700 transition-colors" whileHover={{
                  scale: 1.02
                }} whileTap={{
                  scale: 0.98
                }} data-id="element-1158">
                    Submit Reservation Request
                  </motion.button>
                </form>
              </motion.div>
              <motion.div initial={{
              opacity: 0,
              x: 30
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.7
            }} data-id="element-1159">
                <div className="bg-white p-8 rounded-lg shadow-md h-full" data-id="element-1160">
                  <h3 className="text-xl font-bold text-emerald-800 mb-6" data-id="element-1161">
                    Contact Information
                  </h3>
                  <div className="space-y-6" data-id="element-1162">
                    <div className="flex items-start" data-id="element-1163">
                      <span className="text-emerald-600 mr-4" data-id="element-1164">📍</span>
                      <div data-id="element-1165">
                        <p className="font-medium" data-id="element-1166">Visit Us</p>
                        <p className="text-gray-700" data-id="element-1167">
                          123 Entertainment Avenue
                          <br data-id="element-1168" />
                          Victoria Island, Lagos
                          <br data-id="element-1169" />
                          Nigeria
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start" data-id="element-1170">
                      <span className="text-emerald-600 mr-4" data-id="element-1171">📞</span>
                      <div data-id="element-1172">
                        <p className="font-medium" data-id="element-1173">Call Us</p>
                        <p className="text-gray-700" data-id="element-1174">
                          +234 123 456 7890
                          <br data-id="element-1175" />
                          +234 987 654 3210
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start" data-id="element-1176">
                      <span className="text-emerald-600 mr-4" data-id="element-1177">✉️</span>
                      <div data-id="element-1178">
                        <p className="font-medium" data-id="element-1179">Email Us</p>
                        <p className="text-gray-700" data-id="element-1180">
                          reservations@standardpurity.com
                          <br data-id="element-1181" />
                          events@standardpurity.com
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start" data-id="element-1182">
                      <span className="text-emerald-600 mr-4" data-id="element-1183">🕒</span>
                      <div data-id="element-1184">
                        <p className="font-medium" data-id="element-1185">Hours of Operation</p>
                        <p className="text-gray-700" data-id="element-1186">
                          Restaurant: 12:00 PM - 11:00 PM (Daily)
                          <br data-id="element-1187" />
                          Lounge & Bar: 4:00 PM - 2:00 AM (Sun-Thu)
                          <br data-id="element-1188" />
                          Lounge & Bar: 4:00 PM - 4:00 AM (Fri-Sat)
                        </p>
                      </div>
                    </div>
                    <div className="pt-4 border-t border-gray-200" data-id="element-1189">
                      <p className="font-medium mb-2" data-id="element-1190">Follow Us</p>
                      <div className="flex space-x-4" data-id="element-1191">
                        <a href="#" className="text-emerald-600 hover:text-emerald-800" data-id="element-1192">
                          <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-1193">
                            <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" data-id="element-1194" />
                          </svg>
                        </a>
                        <a href="#" className="text-emerald-600 hover:text-emerald-800" data-id="element-1195">
                          <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-1196">
                            <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" data-id="element-1197" />
                          </svg>
                        </a>
                        <a href="#" className="text-emerald-600 hover:text-emerald-800" data-id="element-1198">
                          <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-1199">
                            <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" data-id="element-1200" />
                          </svg>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </section>
      </main>
      <SubsidiaryFooter name="Standard Purity Entertainment" description="Lagos' premier entertainment hub offering exceptional dining, cocktails, and entertainment experiences." color="bg-emerald-900" textColor="text-white" links={footerLinks} logo="https://uploadthingy.s3.us-west-1.amazonaws.com/pbBPYdNqJU1QtNxrehs2c8/STANDARD_PURITY_2.png" data-id="element-1201" />
    </div>;
}